<template>
  <footer id="footer">
    <div class="footer-top">
      <!-- Logo & Info -->
      <div class="top-info">
        <img src="@/assets/img/logo_small.png" />
        <div class="info-text">
          {{ $t('footer.1') }}
          <span class="gradient-green">{{ $t('footer.2') }}</span>
        </div>
      </div>

      <!-- Links -->
      <div class="top-links">
        <!-- Oyunlar -->
        <div class="links-section">
          <div class="section-title">{{ $t('footer.3') }}</div>
          <router-link to="/battles"><IconBattles /><span class="gradient-orange">Battles</span></router-link>
          <router-link to="/crash"><IconCrash /><span class="gradient-yellow">Crash</span></router-link>
          <router-link to="/roll"><IconRoll /><span class="gradient-green">Roll</span></router-link>
          <router-link to="/duels"><IconDuels /><span class="gradient-red">Dice Duels</span></router-link>
        </div>

        <!-- Kurallar -->
        <div class="links-section">
          <div class="section-title">{{ $t('footer.4') }}</div>
          <button @click="modalsSetShow('Terms')">{{ $t('footer.5') }}</button>
          <button @click="modalsSetShow('Faq')">{{ $t('footer.6') }}</button>
          <button @click="modalsSetShow('Privacy')">{{ $t('footer.7') }}</button>
        </div>

        <!-- Bilgiler -->
        <div class="links-section">
          <div class="section-title">{{ $t('footer.8') }}</div>
          <router-link to="/affiliates">{{ $t('footer.9') }}</router-link>
          <router-link to="/leaderboard">{{ $t('footer.10') }}</router-link>
          <button @click="modalsSetShow('Fair')">{{ $t('footer.12') }}</button>
        </div>

        <!-- Sosyal Medya -->
        <div class="links-section">
          <div class="section-title">{{ $t('footer.13') }}</div>

          <!-- her ikon koşullu render ediliyor -->
          <a v-if="socialLinks.twitter" :href="socialLinks.twitter" target="_blank">
           
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
  <defs>
    <linearGradient id="gold-gradient" gradientTransform="rotate(420)">
      <stop offset="0%" stop-color="rgb(255, 206, 0)" />
      <stop offset="49%" stop-color="rgb(255, 206, 0)" />
      <stop offset="49%" stop-color="rgb(255, 184, 0)" />
      <stop offset="100%" stop-color="rgb(255, 184, 0)" />
    </linearGradient>
  </defs>

  <path fill="url(#gold-gradient)" fill-rule="evenodd"
        d="M5 1a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4V5a4 4 0 0 0-4-4zm-.334 3.5a.75.75 0 0 0-.338 1.154l5.614 7.45l-5.915 6.345l-.044.051H6.03l4.83-5.179l3.712 4.928a.75.75 0 0 0 .337.251h4.422a.75.75 0 0 0 .336-1.154l-5.614-7.45L20.017 4.5h-2.05l-4.83 5.18l-3.714-4.928a.75.75 0 0 0-.337-.252z"/>
</svg>


            Twitter
          </a>

          <a v-if="socialLinks.discord" :href="socialLinks.discord" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" width="21.6" height="24" viewBox="0 0 18 20"><path fill="#fbbf24" d="M15.45 0c1.118 0 2.031.901 2.05 2.025V20l-2.15-1.9l-1.21-1.12l-1.28-1.19l.53 1.85H2.05A2.055 2.055 0 0 1 0 15.615V2.06C0 .932.901.019 2.015 0zM7.32 4.78l-.1-.12h-.057c-.273.009-1.486.1-2.753 1.05l-.048.092c-.251.49-1.392 2.872-1.392 5.738l.02.033c.142.217 1.019 1.423 3.03 1.487l.295-.361l.375-.469c-1.166-.349-1.666-1.051-1.74-1.164l-.01-.016l.041.027q.07.047.239.143c.01.01.02.02.04.03c.03.02.06.03.09.05c.25.14.5.25.73.34c.41.16.9.32 1.47.43c.729.136 1.58.187 2.508.025l.082-.015c.47-.08.95-.22 1.45-.43c.35-.13.74-.32 1.15-.59l-.016.025c-.096.14-.62.833-1.794 1.165l.165.207c.253.314.495.603.495.603c2.21-.07 3.06-1.52 3.06-1.52c0-3.22-1.44-5.83-1.44-5.83c-1.238-.929-2.425-1.037-2.733-1.049L10.4 4.66l-.14.16c1.508.461 2.3 1.103 2.46 1.243l.03.027a8.15 8.15 0 0 0-5.03-.94c-.06 0-.11.01-.17.02l-.056.005c-.38.039-1.197.179-2.214.625l-.145.068c-.182.086-.314.153-.385.19l-.06.032s.813-.774 2.576-1.294zm-.38 3.61c.57 0 1.03.5 1.02 1.11c0 .61-.45 1.11-1.02 1.11c-.56 0-1.02-.5-1.02-1.11s.45-1.11 1.02-1.11m3.65 0c.57 0 1.02.5 1.02 1.11s-.45 1.11-1.02 1.11c-.56 0-1.02-.5-1.02-1.11s.45-1.11 1.02-1.11"/></svg>
             Discord
          </a>

          <a v-if="socialLinks.telegram" :href="socialLinks.telegram" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#fbbf24" fill-rule="evenodd" d="M5 1a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4V5a4 4 0 0 0-4-4zm15 11a8 8 0 1 1-16 0a8 8 0 0 1 16 0m-13.468-.236c0-.074.049-.145.118-.17l8.963-3.417a.19.19 0 0 1 .185.034c.05.043.072.114.057.179l-1.788 7.518a.18.18 0 0 1-.114.129a.18.18 0 0 1-.17-.023l-3.375-2.718l3.012-2.702a.11.11 0 0 0 .017-.142a.11.11 0 0 0-.139-.036l-4.475 2.311l-2.173-.793a.19.19 0 0 1-.118-.17" clip-rule="evenodd"/></svg>
            Telegram
          </a>

          <a v-if="socialLinks.instagram" :href="socialLinks.instagram" target="_blank">
           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 1000 1000"><path fill="#fbbf24" d="M603.575 510.854c0-54.044-44.172-98.02-98.463-98.02c-54.285 0-98.455 43.977-98.455 98.02c0 54.058 44.17 98.026 98.455 98.026c54.291 0 98.463-43.968 98.463-98.026M749.855.602H250.142C112.465.602.456 112.124.456 249.199v69.266h367.413c38.769-27.496 86.118-43.739 137.243-43.739s98.48 16.243 137.251 43.739H999.54v-69.266C999.54 112.123 887.531.602 749.855.602m101.12 236.435c0 15.191-12.48 27.622-27.743 27.622h-85.72c-15.261 0-27.743-12.431-27.743-27.622v-85.352c0-15.19 12.481-27.622 27.743-27.622h85.72c15.262 0 27.743 12.43 27.743 27.622zM742.287 510.854c0 130.215-106.402 236.133-237.176 236.133c-130.778 0-237.17-105.918-237.17-236.133c0-35.848 8.11-69.845 22.532-100.318H.456v340.263c0 137.085 112.009 248.597 249.686 248.597h499.714c137.676 0 249.685-111.513 249.685-248.597V410.536H719.755c14.422 30.473 22.532 64.47 22.532 100.318"/></svg>
            Instagram
          </a>

          <a v-if="socialLinks.facebook" :href="socialLinks.facebook" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#fbbf24" fill-rule="evenodd" d="M5 1a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4V5a4 4 0 0 0-4-4zm0 4h14v14h-4.454v-5.09h1.342l.477-1.91h-1.82v-1.59c0-.528.428-.955.955-.955h.954v-1.91h-1.59c-1.23 0-2.228.998-2.228 2.228V12h-1.59v1.91h1.59V19H5z" clip-rule="evenodd"/></svg>
            Facebook
          </a>

          

          <a v-if="socialLinks.tiktok" :href="socialLinks.tiktok" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#fbbf24" fill-rule="evenodd" d="M5 1a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4V5a4 4 0 0 0-4-4zm7.34 3.5h2.387c0 1.6 1.352 3.41 3.41 3.41v2.386c-1.417-.098-2.628-.33-3.41-1.023v6.136c0 1.705-1.348 4.091-4.431 4.091c-3.766 0-4.432-3.41-4.432-4.432s.6-4.432 4.772-4.432v2.387c-1.091-.231-2.386.681-2.386 2.045c0 1.705 1.023 2.046 2.046 2.046s2.045-1.023 2.045-2.046z" clip-rule="evenodd"/></svg>
            TikTok
          </a>

          <a v-if="socialLinks.reddit" :href="socialLinks.reddit" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#fbbf24" fill-rule="evenodd" d="M5 1a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4V5a4 4 0 0 0-4-4zm10.38 5.74l-2.235-.497l-.519 3.11c1.55.095 2.967.54 4.065 1.235a1.956 1.956 0 1 1 2.22 3.165q.022.188.022.38c0 1.412-.858 2.625-2.112 3.461c-1.257.838-2.963 1.34-4.821 1.34s-3.564-.502-4.821-1.34c-1.254-.836-2.112-2.049-2.112-3.46q0-.194.02-.381a1.955 1.955 0 1 1 2.222-3.165c1.139-.721 2.62-1.173 4.237-1.245l.639-3.83a.534.534 0 0 1 .642-.434l2.864.637a1.6 1.6 0 1 1-.311 1.023Zm-6.224 7.393a1.067 1.067 0 1 0 0-2.133a1.067 1.067 0 0 0 0 2.133m5.688 0a1.067 1.067 0 1 0 0-2.133a1.067 1.067 0 0 0 0 2.133m-4.89 1.482a.533.533 0 0 0-.887.592c.218.326.623.553 1.08.7c.48.155 1.1.249 1.853.249s1.373-.094 1.852-.248c.458-.148.863-.375 1.08-.701a.533.533 0 1 0-.887-.592c-.02.03-.148.158-.52.277c-.35.113-.855.197-1.525.197s-1.175-.084-1.526-.197c-.37-.12-.5-.247-.52-.277" clip-rule="evenodd"/></svg>
            Reddit
          </a>

        

          <a v-if="socialLinks.github" :href="socialLinks.github" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#fbbf24" fill-rule="evenodd" d="M5 1a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4V5a4 4 0 0 0-4-4zm1.815 5.11a8 8 0 0 1 5.182-1.903a7.99 7.99 0 0 1 2.531 15.572c-.405.077-.535-.159-.535-.372v-2.212a1.9 1.9 0 0 0-.546-1.473c1.78-.197 3.648-.871 3.648-3.942a3.1 3.1 0 0 0-.822-2.146a2.87 2.87 0 0 0-.08-2.114s-.666-.214-2.194.82a7.56 7.56 0 0 0-4.002 0C8.472 7.306 7.8 7.52 7.8 7.52a2.87 2.87 0 0 0-.078 2.114a3.1 3.1 0 0 0-.823 2.144c0 3.063 1.866 3.748 3.64 3.95a1.7 1.7 0 0 0-.508 1.065a1.7 1.7 0 0 1-2.325-.664a1.68 1.68 0 0 0-1.224-.823s-.78-.01-.054.487c.426.271.74.686.887 1.168c0 0 .459 1.535 2.682 1.053c.003.504.002.929 0 1.19v.2c0 .21-.126.445-.525.375A7.99 7.99 0 0 1 6.815 6.11" clip-rule="evenodd"/></svg>
            GitHub
          </a>

         
        </div>
      </div>
    </div>

    <!-- Ortaklar -->
    <div class="footer-partners" v-if="partners.length">
      <div class="partners-title"> </div>
      <div class="partners-logos">
        <img v-for="(partner, i) in partners" :key="i" :src="partner.logo" :alt="partner.name" />
      </div>
    </div>

    <!-- Lisans -->
    <div class="footer-bottom">
      <span>©2025 RivoBit — Licensed & Regulated</span>
    </div>
  </footer>
</template>

<script>
import { mapActions } from 'vuex';
import IconBattles from '@/components/icons/IconBattles';
import IconCrash from '@/components/icons/IconCrash';
import IconRoll from '@/components/icons/IconRoll';
import IconDuels from '@/components/icons/IconDuels';
import axios from 'axios';

export default {
  name: 'Footer',
  components: { IconBattles, IconCrash, IconRoll, IconDuels },
  data() {
    return {
      socialLinks: {},
      partners: [
        { name: "Partner 1", logo: require('@/assets/img/partner/partner1.avif')},
        { name: "Partner 2", logo: require('@/assets/img/partner/partner2.avif')},
        { name: "Partner 3", logo: require('@/assets/img/partner/partner3.png')}
      ]
    }
  },
  created() {
    this.fetchSocialLinks();
  },
  methods: {
    ...mapActions(['modalsSetShow']),
    async fetchSocialLinks() {
      try {
        const res = await axios.get('/settings/social');
        if (res.data.success) {
          this.socialLinks = res.data.social;
        }
      } catch (e) {
        console.error("Footer social fetch error:", e);
      }
    }
  }
}
</script>


<style>
footer#footer {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 0 12px 0;
}

footer#footer .footer-top {
  width: 100%;
  position: relative;
  display: flex;
  padding-bottom: 32px;
}

footer#footer .footer-top::after {
  content: '';
  width: 100%;
  height: 1px;
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #02192c;
}

footer#footer .top-info {
  width: 245px;
  position: relative;
  padding-right: 25px;
}

footer#footer .top-info::after {
  content: '';
  width: 1px;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  background: linear-gradient(0deg, transparent 50%, #00111f 50%),
    linear-gradient(0deg, rgba(0, 17, 31, 0) 0%, rgba(39, 255, 177, 0.5) 50%, rgba(0, 17, 31, 0) 100%);
  background-size: 1px 2px, 2px 100%;
}

footer#footer .top-info img {
  width: 82px;
}

footer#footer .info-text {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  font-size: 12px;
  font-weight: 400;
  color: #627382;
}

footer#footer .info-text span {
  margin-top: 20px;
  font-size: 12px;
  font-weight: 700;
}

footer#footer .top-links {
  width: calc(100% - 245px);
  padding-left: 40px;
  display: flex;
  font-family: Rubik;
}

footer#footer .links-section {
  margin-right: 40px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

footer#footer .links-section:last-child {
  margin-right: 0;
}

footer#footer .section-title {
  position: relative;
  padding-right: 40px;
  margin-bottom: 20px;
  font-size: 15px;
  font-weight: 700;
  color: #bbbfd0;
}

footer#footer .links-section:last-child .section-title {
  padding-right: 0;
}

footer#footer .section-title::after {
  content: '';
  width: 1px;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  background: linear-gradient(0deg, transparent 50%, #00111f 50%),
    linear-gradient(0deg, rgba(0, 17, 31, 0) 0%, rgba(39, 158, 255, 0.5) 50%, rgba(0, 17, 31, 0) 100%);
  background-size: 1px 2px, 2px 100%;
}

footer#footer .links-section:last-child .section-title::after {
  display: none;
}

footer#footer .links-section a,
footer#footer .links-section button {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 700;
  color: var(--bottom-text);
}

footer#footer .links-section a:last-child,
footer#footer .links-section button:last-child {
  margin-bottom: 0;
}

footer#footer .links-section a svg,
footer#footer .links-section button svg {
  margin-right: 9px;
}

.footer-partners {
  width: 100%;
  margin: 30px 0;
  text-align: center;
}
.footer-partners .partners-title {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 15px;
  color: #bbbfd0;
}
.footer-partners .partners-logos {
  display: flex;
  justify-content: center;
  gap: 20px;
}
.footer-partners img {
  height: 30px;
  object-fit: contain;
}

footer#footer .footer-bottom {
  margin-top: 15px;
  text-align: center;
}

footer#footer .footer-bottom span {
  font-size: 12px;
  font-weight: 600;
  color: #9ab6ff;
}

/* Responsive */
@media only screen and (max-width: 1600px) {
  footer#footer {
    padding: 50px 20px 12px 20px;
  }
}

@media only screen and (max-width: 950px) {
  footer#footer {
    padding: 30px 20px 12px 20px;
    padding-bottom: 80px;
  }
  footer#footer .footer-top {
    flex-direction: column-reverse;
    padding-bottom: 15px;
  }
  footer#footer .top-info {
    width: 100%;
    display: flex;
    align-items: center;
    padding-top: 25px;
    padding-right: 0;
  }
  footer#footer .info-text {
    width: calc(100% - 82px);
    margin-top: 0;
    padding-left: 25px;
  }
  footer#footer .top-info::after {
    width: 100%;
    height: 0;
    border-top: 1px dotted #02192c;
  }
  footer#footer .top-links {
    width: 100%;
    padding-bottom: 25px;
    padding-left: 0;
  }
}

@media only screen and (max-width: 700px) {
  footer#footer .top-links {
    flex-wrap: wrap;
  }
  footer#footer .links-section:nth-child(4) {
    margin-top: 25px;
  }
  footer#footer .links-section {
    width: 33.33%;
    margin-right: 0;
  }
  footer#footer .links-section .section-title {
    padding-right: 0;
  }
  footer#footer .links-section .section-title:after {
    display: none;
  }
}

@media only screen and (max-width: 450px) {
  footer#footer .links-section {
    width: 50%;
  }
  footer#footer .links-section:nth-child(3) {
    margin-top: 25px;
  }
}
</style>
